export default {
  apiKey: 'b0218b8fdd59414b90004c65199560a1',
  airports: {
    url: 'https://api.transavia.com/v2/airports/',
  },
  routes: {
    url: 'https://api.transavia.com/v3/routes/',
  },
  flightOffers: {
    url: 'https://api.transavia.com/v1/flightoffers/',
    daterange: 1, // nr of days in the past and future from the selected date
  },
}
